module.exports = __webpack_public_path__ + "img/ic_book.438c3116.png";